import { ReactComponent as ThinnectLogo } from './../assets/icons/Thinnect_white.svg';
import footerMobilePicture from '../assets/img/footer_login_mobile.png';
import footerMediumPicture from '../assets/img/footer_login_medium.png';
import footerLargePicture from '../assets/img/footer_login_large.png';
import './MainFooter.scss';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

type Props = {
	isLoggedIn: boolean;
	isRoomView: boolean;
};

const MainFooter = ({ isLoggedIn, isRoomView }: Props) => {
	const { t } = useTranslation();

	return isLoggedIn ? (
		<footer className="mt-auto footer">
			{isRoomView && (
				<div className="d-flex mt-5 justify-content-center">
					<Button href="https://thinnect.com/" variant="info">
						{t('footer.area_more_info')}
					</Button>
				</div>
			)}
			<small className="my-5 d-flex flex-column align-items-center">
				<a
					className="d-flex flex-column flex-sm-row align-items-center text-decoration-none text-reset"
					href="https://thinnect.com/"
				>
					<span className="me-0 me-sm-2  ">{t('common.solution_provided')}</span>
					<ThinnectLogo className="thinnect-footer-logo" />
				</a>
				{process.env.REACT_APP_VERSION && (
					<span className="mt-1">
						{t('footer.foot_version')} {process.env.REACT_APP_VERSION}
					</span>
				)}
			</small>
		</footer>
	) : (
		<footer className="footer">
			<picture>
				<source media="(min-width:1200px)" srcSet={footerMediumPicture} />
				<source media="(min-width:576px)" srcSet={footerLargePicture} />
				<img src={footerMobilePicture} alt="Mobile login footer" />
			</picture>
		</footer>
	);
};

export default MainFooter;
